import { useEffect, useRef } from 'react';
import { subscribeLiveRefresh, trailingAsync } from '@/lib/liveRefresh';

export function useLiveRefresh(callback, {
  enabled = true,
  immediate = true,
  intervalMs,
} = {}) {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    if (!enabled) return undefined;
    const run = trailingAsync(() => cbRef.current());
    return subscribeLiveRefresh(run, { immediate, intervalMs });
  }, [enabled, immediate, intervalMs]);
}
